var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 68,
    viewBox: "0 0 59 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3771 41.7359C36.1952 41.7359 41.7456 36.1855 41.7456 29.3674C41.1271 12.9792 17.627 12.9792 17.0086 29.3674C17.0086 36.1855 22.559 41.7359 29.3771 41.7359ZM22.0951 28.2697C22.6981 27.6667 23.6721 27.6667 24.2751 28.2697L27.7228 31.7174L34.3709 23.7397C34.912 23.0904 35.886 22.9976 36.5508 23.5388C37.2001 24.0799 37.2929 25.0539 36.7518 25.7187L29.0215 34.9951C28.4649 35.6908 27.3518 35.7372 26.7333 35.1033L22.0951 30.4651C21.4922 29.8621 21.4922 28.8727 22.0951 28.2697Z",
    fill: "url(#paint0_linear_304_1801)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.450308 30.4651L8.14969 38.1645V49.0487C8.14969 49.8991 8.84541 50.5948 9.69575 50.5948H20.58L28.2794 58.2942C28.5731 58.5725 28.9597 58.7425 29.3771 58.7425C29.7945 58.7425 30.181 58.5725 30.4748 58.2942L38.1742 50.5948H49.0584C49.9088 50.5948 50.6045 49.8991 50.6045 49.0487V38.1645L58.3039 30.4651C58.9068 29.8621 58.9068 28.8881 58.3039 28.2852L50.6045 20.5858V9.68607C50.6045 8.83573 49.9088 8.14001 49.0584 8.14001H38.1742L30.4748 0.440627C29.8873 -0.146876 28.8669 -0.146876 28.2948 0.440627L20.5955 8.14001H9.71121C8.86087 8.14001 8.16515 8.83573 8.16515 9.68607V20.5703L0.465769 28.2697C-0.152655 28.8727 -0.152655 29.8621 0.450308 30.4651ZM29.3771 13.9068C37.8959 13.9068 44.8377 20.8486 44.8377 29.3674C43.9874 49.8836 14.7668 49.8682 13.9165 29.3674C13.9165 20.8486 20.8583 13.9068 29.3771 13.9068Z",
    fill: "url(#paint1_linear_304_1801)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8244 53.6869L6.4181 61.0462C6.12435 61.5254 6.12435 62.1129 6.40264 62.6077C6.66547 63.087 7.17567 63.3807 7.73225 63.3807H13.0816L15.7099 67.3232C16.2974 68.2508 17.7816 68.2199 18.3228 67.2613L23.7804 58.1705L19.2968 53.6869H10.8244Z",
    fill: "url(#paint2_linear_304_1801)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4419 53.6869L34.9584 58.1705L40.416 67.2613C40.9571 68.2199 42.4413 68.2508 43.0288 67.3232L45.6571 63.3807H51.0219C52.1815 63.4116 52.9854 62.0202 52.3515 61.0462L47.9453 53.6869H39.4419Z",
    fill: "url(#paint3_linear_304_1801)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_1801",
    x1: 0.00166278,
    y1: 33.995,
    x2: 58.7626,
    y2: 33.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_304_1801",
    x1: 0.00166278,
    y1: 33.995,
    x2: 58.7626,
    y2: 33.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_304_1801",
    x1: 0.00166278,
    y1: 33.995,
    x2: 58.7626,
    y2: 33.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_304_1801",
    x1: 0.00166278,
    y1: 33.995,
    x2: 58.7626,
    y2: 33.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCheck);
export default __webpack_public_path__ + "static/media/round-check.049c0aa54e67c3c74eb5a7b58353832f.svg";
export { ForwardRef as ReactComponent };